import { formatNumber } from "@/utils/format-fr";

/**
 * A ListView size as the server counts it: up to `limit + 1`, never the full table. Above the limit the
 * exact size is unknown, so it reads "more than {limit}"; `null` is a ListView the server could not count.
 */
export function formatCount(count: number, limit: number): string {
    return count > limit ? `more than ${formatNumber(limit)}` : formatNumber(count);
}

export function recordsLabel(count: number | null, limit: number): string | null {
    return count === null ? null : `${formatCount(count, limit)} records`;
}
